// Group GROUP 18. Number, Agreement, Pronouns
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group18Data = {
  "id": "group_18",
  "title": {
    "tc": "數量/一致/代詞",
    "sc": "数量/一致/代词",
    "en": "Number, Agreement, Pronouns"
  },
  "subtitle": {
    "tc": "Number, Agreement, Pronouns",
    "sc": "Number, Agreement, Pronouns",
    "en": "Number, Agreement, Pronouns"
  },
  "icon": "🔢",
  "difficulty": "intermediate",
  "color": "from-blue-500 to-blue-600",
  "topics": [
    {
      "id": "collectives_agreement",
      "title": {
        "tc": "集合名詞一致",
        "sc": "集合名词一致",
        "en": "Collectives and Agreement"
      },
      "description": {
        "tc": "學習集合名詞的一致性",
        "sc": "学习集合名词的一致性",
        "en": "Learn collective noun agreement"
      },
      "icon": "👥",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "collective_1",
          "sentence": "The team are winning. (BrE)",
          "analysis": "The team (S-collective) are (V) winning (V).",
          "translation": {
            "tc": "這個團隊正在獲勝。（英式英語）",
            "sc": "这个团队正在获胜。（英式英语）",
            "en": "The team are winning. (BrE)"
          }
        },
        {
          "id": "collective_2",
          "sentence": "The team is winning. (AmE)",
          "analysis": "The team (S-collective) is (V) winning (V).",
          "translation": {
            "tc": "這個團隊正在獲勝。（美式英語）",
            "sc": "这个团队正在获胜。（美式英语）",
            "en": "The team is winning. (AmE)"
          }
        },
        {
          "id": "collective_3",
          "sentence": "The committee has decided.",
          "analysis": "The committee (S) has (V) decided (V).",
          "translation": {
            "tc": "委員會已經決定了。",
            "sc": "委员会已经决定了。",
            "en": "The committee has decided."
          }
        },
        {
          "id": "collective_4",
          "sentence": "The police are investigating.",
          "analysis": "The police (S-plural) are (V) investigating (V).",
          "translation": {
            "tc": "警方正在調查。",
            "sc": "警方正在调查。",
            "en": "The police are investigating."
          }
        },
        {
          "id": "collective_5",
          "sentence": "A number of students are absent.",
          "analysis": "A number of (Det) students (S-pl) are (V) absent (C).",
          "translation": {
            "tc": "一些學生缺席了。",
            "sc": "一些学生缺席了。",
            "en": "A number of students are absent."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：集合名詞英美差異；語意作整體或個體影響一致性。",
        "sc": "要点：集合名词英美差异；语义作整体或个体影响一致性。",
        "en": "Key points: collective nouns differ between BrE/AmE; semantics as whole or individuals affects agreement."
      }
    }
  ]
};
